import TextSearchFiltersBlock from './textSearchFiltersBlock'

export default TextSearchFiltersBlock
